import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { PrivacyPage } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'privacy',
    events: {
        'Load Dealer Privacy': emptyProps(),
        'Load Dealer Privacy Success': props<{ privacy: PrivacyPage }>(),
        'Load Dealer Privacy Failure': props<{ error: string }>(),
    },
});
